import { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { FavoriteActivities } from '@src/routes/members/components/status/favorite-activities'
import { MemberProfile } from '@src/data/member-profile'

@Component
export class ReadonlyFavoriteActivities extends FavoriteActivities {

  @Prop({ required: true })
  member: MemberProfile

  renderEditOption (h: CreateElement) {
    return null
  }

  renderEditor (h: CreateElement) {
    return null
  }
}
